module.exports = __webpack_public_path__ + "stylesheets/different-devices_80ef148db89602a4f4ceb67e9c3fa7cf.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/different-devices.less
// module id = Ir05
// module chunks = 154